type Environment = 'development' | 'staging' | 'production' | 'unknown'

export const getEnvironment = (): Environment => {
  const hostname = window.location.hostname

  if (hostname.includes('lvc-dev')) return 'development'
  if (hostname.includes('lvc-stg')) return 'staging'
  if (hostname === 'www.lavitrine.com' || hostname === 'lavitrine.com') return 'production'

  return 'unknown'
}
